import { render, staticRenderFns } from "./ship-image-zoom.vue?vue&type=template&id=4d30bfc3"
import script from "./ship-image-zoom.vue?vue&type=script&lang=js"
export * from "./ship-image-zoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports